import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=d9096b2e&scoped=true"
import script from "./PPagination.vue?vue&type=script&lang=js"
export * from "./PPagination.vue?vue&type=script&lang=js"
import style0 from "./PPagination.vue?vue&type=style&index=0&id=d9096b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9096b2e",
  null
  
)

export default component.exports